import styles from './GestureVocabulary.module.css'

const INPUTS = [
  { name: 'Swipe', text: 'Multi-finger swipes, in any direction.' },
  { name: 'Tap', text: 'Multi-finger taps and double-taps.' },
  { name: 'Firm press', text: 'A firmer press on the trackpad.' },
  { name: 'Drawn shape', text: 'A shape drawn with one finger.' },
]

/**
 * The raw gesture types as full-width editorial rows. The gesture names
 * carry the composition; explanations stay deliberately quiet beside them.
 */
export function GestureVocabulary() {
  return (
    <ul className={styles.list}>
      {INPUTS.map((item) => (
        <li key={item.name} className={styles.row}>
          <span className={styles.rule} aria-hidden="true" />
          <span className={styles.name}>{item.name}</span>
          <span className={styles.text}>{item.text}</span>
        </li>
      ))}
    </ul>
  )
}
